//Import ADV components css
import '@sbt-web/adv/dist/cjs/index.css';
export { AdsGAMPlacement } from './AdsGAMPlacement';
